// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2YR9A","loaderOuter":"PageOverlayLoader_loaderOuter__2QcV3"};